import React, { useCallback, useEffect, useState } from 'react';
import { useAPI } from '../../frontend/components/APIProvider';
import './ConversationViewPage.scss';
import { ConversationHistory } from './ConversationHistory';
import globalWebChatEventConnectionManager from '../../web_chat/frontend/WebChatEventConnectionManager';

export default function LiveConversationHistory({
  conversation,
  scrollElementQuerySelector = '.main-content-area',
}) {
  const api = useAPI();
  const [events, setEvents] = React.useState([]);

  function scrollToBottom() {
    const mainContentArea = document.querySelector(scrollElementQuerySelector);
    if (mainContentArea) {
      mainContentArea.scrollTop = mainContentArea.scrollHeight;
    }
  }

  const addEvent = useCallback((newEventData) => {
    setEvents((events) => {
      // Double check to see if it's a new event or an existing one.
      let isExistingEvent = false;
      for (let i = 0; i < events.length; i++) {
        if (events[i].id === newEventData.id) {
          isExistingEvent = true;
        }
      }

      if (isExistingEvent) {
        // Replace the existing event data with the new event
        return events.map((event) => {
          if (event.id === newEventData.id) {
            return newEventData;
          } else {
            return event;
          }
        });
      } else {
        return [...events, newEventData];
      }
    });
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }, []);

  useEffect(() => {
    globalWebChatEventConnectionManager.updateEventHandle(addEvent);
  }, [addEvent]);

  const startListeningForMessages = useCallback(
    (conversationId, conversationToken, mostRecentEventTime) => {
      globalWebChatEventConnectionManager.subscribeToEvents(
        conversationId,
        conversationToken,
        mostRecentEventTime,
        addEvent
      );
    },
    [addEvent]
  );

  React.useEffect(() => {
    api.getRecentEvents(conversation?.id).then((data) => {
      const reversedMessaged = data.messages;
      reversedMessaged.reverse();
      setEvents(reversedMessaged);

      if (conversation.status === 'active') {
        const mostRecentMessage = data.messages[data.messages.length - 1];
        startListeningForMessages(
          conversation._id,
          conversation?.metadata?.conversation_token,
          mostRecentMessage?.created_at ??
            new Date(new Date().getTime() - 1000 * 3600 * 24 * 7).toISOString()
        );
        setTimeout(() => {
          scrollToBottom();
        }, 100);
      }
    });
  }, [
    startListeningForMessages,
    conversation?.id,
    api,
    conversation.status,
    conversation._id,
    conversation?.metadata?.conversation_token,
  ]);

  React.useEffect(() => {
    return () => {
      globalWebChatEventConnectionManager.disconnect();
    };
  }, []);

  return (
    <ConversationHistory
      events={events}
      onlyShowMessages={false}
      conversation={conversation}
    />
  );
}
